import { render, staticRenderFns } from "./AdminCustomerDetail.vue?vue&type=template&id=1f51fcfa&scoped=true"
import script from "./AdminCustomerDetail.vue?vue&type=script&lang=js"
export * from "./AdminCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerDetail.vue?vue&type=style&index=0&id=1f51fcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51fcfa",
  null
  
)

export default component.exports